import { loadScriptOnce } from '../loaders/script'

export async function enableTopMail(counterId) {
  if (!counterId) return

  window._tmr = window._tmr || []
  window._tmr.push({ id: String(counterId), type: 'pageView', start: Date.now() })

  await loadScriptOnce('https://top-fwz1.mail.ru/js/code.js', { id: 'tmr-code' })

  return true
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/vendors/topmail.js